import React from 'react';
import { Snackbar, SnackbarContent } from '@mui/material';
import { Error as ErrorIcon, Info as InfoIcon, Warning as WarningIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { green, amber } from '@mui/material/colors';
import classNames from 'classnames';
import './Snackbar.scss';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const CustomSnackbar = (props) => {
  const { vertical = 'top', horizontal = 'center' } = props;
  const Icon = variantIcon[props.type];
  const variantClass = `snackbar-${props.type}`;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: vertical,
        horizontal: horizontal,
      }}
      onClose={() => props.closeSnackbar()}
      open={props.open}
      autoHideDuration={5000}
    >
      <SnackbarContent
        className={classNames(variantClass, 'snackbar-margin')}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className="snackbar-message">
            <Icon className={classNames('snackbar-icon', 'snackbar-icon-variant')} />
            {props.message}
          </span>
        }
      />
    </Snackbar>
  );
}

export default CustomSnackbar;